<template>
  <div class="text-left">
    <div class="t-title">솔루션 이용 플랜 수정</div>

    <div class="t-subtitle">이용중인 서비스 - 다음 결제일 갱신 예정 내역</div>
    <div class="t-body">지금 중지하면 다음 결제일에 아래 항목은 더 이상 결제, 갱신되지 않습니다.</div>
    <table class="table amt-table">
      <thead>
      <tr>
        <th class="col-2">결제 예정일</th>
        <th class="col-1">구분</th>
        <th class="col-3">내용</th>
        <th class="col-1">플랜</th>
        <th class="col-3">서비스 이용기간</th>
        <th class="col-1">정산금액</th>
      </tr>
      </thead>
      <tbody>
      <!-- 솔루션 -->
      <tr>
        <td>{{ datesFormat(service.plan.next_date, 'date_3') }}</td>
        <td>플랜</td>
        <td>{{ service.plan.name }}</td>
        <td>{{ service.plan.date_unit }}개월</td>
        <td>{{ datesFormat(service.plan.use_start_date, 'date_3') }}~{{ datesFormat(service.plan.use_end_date, 'date_3') }}</td>
        <td>{{ service.plan.price | currency }}</td>
      </tr>
      <!-- 호스팅 -->
      <tr v-if="service.hosting_info">
        <td>{{ datesFormat(service.hosting_info.next_date, 'date_3') }}</td>
        <td>호스팅</td>
        <td>{{ service.hosting }}</td>
        <td>{{ service.hosting_info.date_unit }}개월</td>
        <td>{{ datesFormat(service.hosting_info.use_start_date, 'date_3') }}~{{ datesFormat(service.hosting_info.use_end_date, 'date_3') }}</td>
        <td>{{ service.hosting_info.price | currency }}</td>
      </tr>
      <tr v-for="(order, order_idx) in service.service_app_order" :key="`order-${order_idx}`">
        <template>
          <td>{{ datesFormat(order.next_date, 'date_3') }}</td>
          <td>{{ order.product.category2_name }}</td>
          <td>{{ order.product.name }}</td>
          <td>{{ order.date_unit }}개월</td>
          <td>{{ datesFormat(order.use_start_date, 'date_3') }}~{{ datesFormat(order.use_end_date, 'date_3') }}</td>
          <td>{{ order.price | currency }}</td>
        </template>
      </tr>
      </tbody>
    </table>
    <div class="flex-price">
      <span class="title-price">갱신 예정 금액</span>
      <span class="price">{{ nextPrice | currency }}</span>
    </div>

    <template v-if="selectedServiceStatus !== 100">
    <div class="t-subtitle">솔루션 이용 해지 완료 후 서비스 호스팅</div>
    <div class="t-body">{{ datesFormat(service.plan.next_date, 'date_3') }}에 결제 예정<br>
      선택하신 서비스 상태는 이후에도 원하는 대로 변경할 수 있습니다.</div>


    <table class="table amt-table" style="width:100%">
      <thead>
      <tr>
        <th class="col-1">구매일</th>
        <th class="col-2">결제(예정)일</th>
        <th class="col-1">구분</th>
        <th class="col-3">내용</th>
        <th class="col-1">플랜</th>
        <th class="col-3">서비스 이용기간</th>
        <th class="col-1">금액</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{ moment().format('YYYY.MM.DD') }}</td>
        <td>{{ moment(service.plan.next_date).format('YYYY.MM.DD') }}</td>
        <td>호스팅</td>
        <td>해지 후 호스팅: {{ selectedServiceStatusText }}</td>
        <td>1개월</td>
        <td>{{ moment().format('YYYY.MM.DD') }}~
          {{ moment(service.plan.next_date).subtract(1, 'days').format('YYYY.MM.DD') }}</td>
        <td>{{ hostingPrice | currency }}</td>
      </tr>
      </tbody>
    </table>
    <div class="flex-price">
      <span class="title-price">다음 결제일에 청구 될 금액</span>
      <span class="price">{{ hostingPrice | currency }}</span>
    </div>

    <div class="flex-price" style="margin-top: 16px;font-size:16px">
      <span class="title-price">총 결제 금액</span>
      <span class="price">{{ hostingPrice | currency }}</span>
    </div>

    <div class="flex-center" style="margin-top:39px;margin-bottom:21px">
      <lp-check-bool :checkedVal.sync="check"
                     label="솔루션 이용 해지 후 서비스 유지를 위한 호스팅비가 결제 됨을 확인하였습니다."></lp-check-bool>
    </div>
    </template>

    <div class="flex-center" style="margin-top: 32px">
      <button class="button t-modal-btn" @click="stop">이용 중지</button>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import ToolTip1 from "../../../module/common/ToolTip1";
  export default {
    name: "MarketTerminateModal",
    props: {
      service: {
        type: Object
      },
      selectedServiceStatus: {
        type: Number
      }
    },
    components: {ToolTip1, LpCheckBool},
    created() {
    },
    data() {
      return {
        check: false
      }
    },
    computed: {
      // 갱신 예정 금액
      nextPrice() {
        let price = 0;
        price += this.service.plan.price;
        price += this.service.hosting_info.price;
        price += this.service.service_app_order.reduce((a,c) => a + c.price, 0);
        return price;
      },
      hostingPrice() {
        let price = 0;
        if(this.selectedServiceStatus===10) price = this.service.hosting_info.price;
        else if(this.selectedServiceStatus===99) price = this.service.hosting_info.price / 2;
        else if(this.selectedServiceStatus===100) price = 0;
        return price;
      },
      selectedServiceStatusText() {
        return {
          10: '서비스 유지',
          99: '휴면 전환',
          100: '서비스 삭제'
        }[this.selectedServiceStatus];
      },
      currentDate() {
        return this.moment().format('YYYY.MM.DD')
      }
    },
    methods: {
      stop() {
        if(!this.check && this.selectedServiceStatus !== 100) {
          this.toast('확인사항을 체크 후 진행해주세요.');
          return;
        }
        this.$emit('stop', this.hostingPrice);
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .amt-table
    margin 20px 0 12px 0
  .amt-table th,
  .amt-table td
    text-align center
    padding 6px 0

  .amt-table th
    font-weight 600
    font-size 13px

  .amt-table td
    font-weight 400
    font-size 13px

  .amt-table tr
    border-bottom 1px solid #dddddd

  .amt-table tbody tr:last-child
    border-bottom 1px solid #000000

  .terminate-modal-title
    color #363636
    font-weight 500
    font-size 13px

  .terminate-modal-content
    color #363636
    font-width 400
    font-size 11px

  .t-modal-btn
    width 230px
    height 32px
    background $primary
    color white
    border-radius 4px
    font-size 13px !important
    font-weight 400

  .t-title
    font-size 18px
    font-weight 600
    margin-top -16px
  .t-subtitle
    margin-top 40px
    font-size 14px
    margin-bottom 4px
    font-weight 600
  .t-body
    font-size 13px

  .t-button-group
    margin-top 42px
    display flex
    align-items center
    justify-content center
    gap 0 24px

  .flex-price
    font-size 13px
    text-align right
    .title-price
      font-weight 600
      margin-right 8px

</style>
